<template>
  <div class="container text-block-with-counter">
    <div class="row text-block-with-counter__row">
      <div class="col-sm-6 col-12">
        <default-title
          :title="title"
          :title_tag="title_tag"
        />
        <html-block :content="content"/>
      </div>
      <div class="col-sm-6 col-12 mt-xs-60">
        <div class="row grid-row-gap-20">
          <counter-text
            v-for="(counter, index) in counters"
            class="col-6"
            :title="counter.title"
            :add_plus_symbol="counter.add_plus_symbol"
            :count_to="counter.number"
            :key="`counter_${uid}-${index}`">
          </counter-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import CounterText from "../small_parts/CounterText.vue";

export default {
  name: "TextBlockWithCounter",
  components: {CounterText, DefaultTitle, HtmlBlock},
  props: {
    /**props**/
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    counters: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        number: {
          type: String,
          required: true,
          admin_type: 'number',
        },
        add_plus_symbol: {
          type: Boolean,
          default: false,
          admin_type: 'checkbox',
        },
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      }
    }
    /**props**/
  },
  computed: {
    uid() {
      return this._uid
    },
  }
}
</script>
